module.exports = __webpack_public_path__ + "img/apprehension1.5f8a15c5.jpg";